import {Component, OnInit} from '@angular/core';
import {FaqService} from '../../services/faq.service';
import {ActivatedRoute} from '@angular/router';
import {BreadcrumbsService} from '../../services/breadcrumbs.service';
import {SeoService} from '../../services/seo.service';
import {Title} from '@angular/platform-browser';

@Component({
    selector: 'app-faq',
    templateUrl: './faq.component.html',
    styleUrls: ['./faq.component.scss']
})
export class FaqComponent implements OnInit {
    topic;
    topics = [];
    params = {
        freetext: '',
        id: 0,
        limit: 8,
        limits: [8, 16, 24, 32, 64],
        page: 0,
        pages: 0,
        pageArray: [],
        totalRecords: 0,
        sort: 'faq_topic.sortOrder',
        sorts: [],
    };

    constructor(
        private activatedRoute: ActivatedRoute,
        private faqService: FaqService,
        private breadcrumbsService: BreadcrumbsService,
        private titleService: Title,
        private seoService: SeoService,
    ) {
    }

    ngOnInit(): void {
        this.search();
        this.activatedRoute.params.subscribe(params => {
            const slug = params.slug;
            this.getTopic(slug);
        });
    }

    getTopic(slug) {
        this.faqService.findOneBySlug(slug).subscribe(data => {
            this.topic = data.data;
            this.breadcrumbsService.changeBreadcrumb([
                { text: 'Help', route: ['/help'] },
                { text: this.topic.name }
            ]);
            if (this.topic) {
                this.titleService.setTitle(this.topic.name);
                this.setMetaTags(this.topic);
            }
        });
    }

    search() {
        this.faqService.findAllTopics(this.params).subscribe(data => {
            this.topics = data.data.data;
        });
    }

    toggleExpanded(q) {
        q.expanded = !q.expanded;
    }

    setMetaTags(topic) {
        this.seoService.updateTitle(topic.name);
        this.seoService.addMetaTag('description', topic.content);
        this.seoService.createLinkForCanonicalURL();
    }
}
